<div class="row margin-top-bottom-20px">
  <div class="col-auto">
    <h2>
      <i class="fas fa-address-book"></i> Account
      <strong>{{ accountId }}</strong>
    </h2>
  </div>
  <div class="col-auto ml-auto d-flex">
    <app-account-details-buttons
      *ngIf="accountDetails"
      [disabled]="
        (hasOnlyTrialDispenserRole$ | async) || hasAccountStatusButtonsDisabled
      "
      [accountDetails]="accountDetails"
      [isLoading]="isLoading"
      [users]="allActiveUsers"
      [accountId]="accountId"
      [userPermissions]="userPermissions$ | async"
      [accountHasFailedState]="accountDetails.state === AccountState.Failed"
      [accountState]="accountDetails.state"
      [isAlreadyOnAccount]="isAlreadyOnAccount"
      [isStaffUserOnAccount]="hasStaffUserOnAccount$ | async"
      (openInviteUserModal)="openInviteUserModal()"
      (openInviteStaffUserModal)="openInviteStaffUserModal()"
      (openInvitePartnerUserModal)="openInvitePartnerUserModal()"
      (confirmAddStaffAdmin)="confirmAddStaffAdmin($event)"
      (deleteAccountSuccess)="deleteAccountSuccess()"
      (accountActivate)="accountActivate()"
      (accountLock)="accountLock()"
      (accountSuspend)="accountSuspend()"
      (accountReactivate)="accountReactivate()"
      (accountTerminate)="accountTerminate()"
      (accountDelete)="accountDelete()"
      (accountDeleteCancel)="accountDeleteCancel()"
    ></app-account-details-buttons>
  </div>
</div>
<div *ngIf="accountDetails" class="row">
  <app-alert
    class="col-12"
    icon="exclamation-circle"
    [show]="accountDetails.state === AccountState.Failed"
  >
    Account will be available for use after it has been bootstrapped
  </app-alert>
</div>
<div class="container-fluid">
  <app-tabs
    [tabs]="tabs"
    [activeTab]="activeTab$ | async"
    (change)="changeTab($event)"
  ></app-tabs>
</div>
<ng-container [ngSwitch]="activeTab$ | async">
  <ng-template #empty>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div *ngIf="isLoading">
              <app-loading-spinner>
                Loading account details ...
              </app-loading-spinner>
            </div>

            <span class="text-danger" *ngIf="errorResponse">
              Could not load account details
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="!isLoading && !errorResponse; else empty">
    <ng-container *ngSwitchCase="'detail'">
      <div class="card">
        <div class="card-body">
          <h3><i class="fas fa-info-circle"></i> Details</h3>
          <app-account-settings
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            [hasOrderManagerRole]="hasOrderManagerRole$ | async"
            [userPermissions]="userPermissions$ | async"
            [accountState]="accountDetails.state"
            [accountDetails]="accountDetails"
            [allLicenses]="allLicenses$ | async"
            [currentSmsCredits]="currentSmsCredits"
            [isUpdatingSmsCredits]="isUpdatingSmsCredits"
            [isLoadingSmsCredits]="isLoadingSmsCredits"
            [isUpdatingAudiencePackageSize]="isUpdatingAudiencePackageSize"
            [isUpdatingUserSeats]="isUpdatingUserSeats"
            [isUpdatingSectionsLimit]="isUpdatingSectionsLimit"
            [accountSettings]="accountSettings$ | async"
            [isLoadingAccountSettings]="isLoadingAccountSettings"
            [loadingProAccountIds]="loadingProAccountIds"
            [proAccounts]="proAccounts$ | async"
            [proAccountsIsLoading]="proAccountsIsLoading$ | async"
            [mappedProIds]="mappedProIds$ | async"
            [accountCategories]="accountCategories$ | async"
            [proSyncMigrations]="migrations$ | async"
            [isLoadingMigrations]="isLoadingMigrations$ | async"
            [licensePackages]="licensePackages$ | async"
            [isLoadingLicensePackages]="isLoadingLicensePackages$ | async"
            [licensePackagesError]="licensePackagesError$ | async"
            [licenseBootstrapState]="licensesBootstrapState$ | async"
            [lastUserLoginTime]="lastUserLoginTime"
            [isCrmKeyspaceCreating]="isCrmKeyspaceCreating$ | async"
            [isCrmKeyspaceTimeoutFailed]="isCrmKeyspaceTimeoutFailed$ | async"
            [rebootstrapLicensesIsLoading]="
              rebootstrapLicensesIsLoading$ | async
            "
            [rebootstrapLicensesTimeoutFailed]="
              rebootstrapLicensesTimeoutFailed$ | async
            "
            [emailQuota]="emailQuota"
            [emailMonthlyQuotaIsLoading]="emailMonthlyQuotaIsLoading"
            [emailOneTimeQuotaIsLoading]="emailOneTimeQuotaIsLoading"
            [dkimDomains]="dkimDomains$ | async"
            [upgradeAccountInProgress]="upgradeAccountInProgress"
            [updateAccountInProgress]="updateAccountInProgress"
            [hasSmsCreditSubscription]="hasSmsCreditSubscription$ | async"
            (editAccountSettings)="editAccountSettings($event)"
            (proAccountNewLink)="putProSyncAccount($event)"
            (proAccountDeleteLink)="proAccountDeleteLink($event)"
            (updateSmsCredits)="updateSmsCredits($event)"
            (navigateToMigration)="navigateToMigration($event)"
            (createCrmKeyspace)="createCrmKeyspace()"
            (rebootstrapLicenses)="rebootstrapLicenses()"
            (showLicenses)="changeTab('licenses')"
            (addQuota)="addEmailQuota($event)"
            (upgradeTrial)="upgradeTrial($event)"
            (updateAccount)="updateAccount($event)"
            (updateDkimDomains)="updateDkimDomains($event)"
          ></app-account-settings>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'licenses'">
      <div class="card">
        <div class="card-body">
          <h3><i class="fas fa-box"></i> License packages</h3>
          <app-manage-license-packages
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            [accountDetails]="accountDetails"
            [accountId]="accountId"
            [hasOrderManagerRole]="hasOrderManagerRole$ | async"
            [hasWawRole]="hasWawRole$ | async"
            [isUpdatingLicense]="isUpdatingLicense"
            [canPlaceOrders]="canPlaceOrders"
            [licensePackages]="licensePackages$ | async"
            [isLoadingLicensePackages]="isLoadingLicensePackages$ | async"
            [licensePackagesError]="licensePackagesError$ | async"
            [licenseBootstrapState]="licensesBootstrapState$ | async"
            [sectionsTotal]="getAccountSectionsTotal$ | async"
            [isUpdatingUserSeats]="isUpdatingUserSeats"
            [slimPackageNotEnabled]="!!(slimPackage !== 'Enabled')"
            [disablePackage]="disablePackage$ | async"
            (updateLicensePackage)="openConfirmUpdateLicensePackage($event)"
          ></app-manage-license-packages>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'feature-toggles'">
      <div class="card">
        <div class="card-body">
          <h3><i class="fas fa-unlock"></i> Feature toggles</h3>
          <app-feature-toggles
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            [groups]="featureToggleGroupNode$ | async"
            [account]="accountDetails"
            [loading]="featureTogglesLoading$ | async"
            (addFeatureToggleLicense)="addFeatureToggleLicense($event)"
          ></app-feature-toggles>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'account-users'">
      <div class="card">
        <div class="card-body">
          <app-account-user-list
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            listTitle="Active Users"
            [users]="users"
            [icon]="'fa-users-cog'"
            [accountSettings]="accountSettings$ | async"
            [accountId]="accountId"
            [allLicenses]="allLicenses$ | async"
            [usersCount]="usersCount$ | async"
            [isDownloadingReport]="isDownloadingUserReport"
            (openDeleteFromAccountModal)="openConfirmDeleteUserModal($event)"
            (downloadReport)="downloadUserReport()"
          ></app-account-user-list>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'support-users'">
      <div class="card">
        <div class="card-body">
          <app-account-user-list
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            listTitle="Support Users"
            [users]="supportUsers"
            [icon]="'fa-users-cog'"
            (openDeleteFromAccountModal)="openConfirmDeleteUserModal($event)"
            [accountSettings]="accountSettings$ | async"
            [accountId]="accountId"
            [allLicenses]="allLicenses$ | async"
            [usersCount]="null"
            [support]="true"
          ></app-account-user-list>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'deactivated-users'">
      <div class="card">
        <div class="card-body">
          <app-account-user-list
            *ngIf="deactivatedUsers?.length"
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            listTitle="Deactivated Users"
            [users]="deactivatedUsers"
            [icon]="'fa-ban'"
            [accountSettings]="accountSettings$ | async"
            [accountId]="accountId"
            [allLicenses]="allLicenses$ | async"
            [usersCount]="0"
            [deactivated]="true"
            (openDeleteFromAccountModal)="openConfirmDeleteUserModal($event)"
          ></app-account-user-list>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'proSync'">
      <div class="card">
        <div class="card-body">
          <h3><i class="fas fa-file-import"></i> ProSync Migrations</h3>
          <app-migrations-accounts-table
            [disabled]="
              (hasOnlyTrialDispenserRole$ | async) || hasAccountBeenDisabled
            "
            [migrations]="migrations$ | async"
            [isLoadingAccounts]="isLoadingMigrations$ | async"
            [searchQuery]="''"
            [stateFilter]="[]"
            [fixedHeader]="false"
            [showLogButtons]="false"
          >
          </app-migrations-accounts-table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'integrations'">
      <div class="card">
        <div class="card-body">
          <app-account-integrations
            [accountId]="accountId"
            [integrationsLoading]="integrationsLoading$ | async"
            [integrations]="integrations$ | async"
          ></app-account-integrations>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
